import { get } from './common';

export default {
    getEnableOnlineAuction: async () => get(`/v1.0/FeatureFlags/EnableOnlineAuction/public`),
}
